import { useEffect, useState } from 'react';
import useTombFinance from './useTombFinance';
import { AutoCompounder } from '../tomb-finance/types';

const useNextHarvestTime = (bank: AutoCompounder) => {
    const [nextHarvestTime, setNextHarvestTime] = useState<Date | null>(null);
    const [loading, setLoading] = useState(true);
    const tombFinance = useTombFinance();

    useEffect(() => {
        let mounted = true;

        const fetchNextHarvestTime = async () => {
            try {
                console.log("bank.linkCompounder", bank.linkCompounder)
                const linkCompounderContract = tombFinance.contracts[bank.compounderContract];
                const lastHarvestTime = await linkCompounderContract.lastHarvestTime();
                console.log("lastHarvestTime", lastHarvestTime)
                // Convert BigNumber timestamp to milliseconds and add 3 hours
                const nextHarvest = new Date(lastHarvestTime.toNumber() * 1000 + (3 * 60 * 60 * 1000));
                
                if (mounted) {
                    setNextHarvestTime(nextHarvest);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching next harvest time:', error);
                if (mounted) {
                    setNextHarvestTime(null);
                    setLoading(false);
                }
            }
        };

        fetchNextHarvestTime();

        // Refresh every minute
        const interval = setInterval(fetchNextHarvestTime, 60 * 1000);

        return () => {
            mounted = false;
            clearInterval(interval);
        };
    }, [bank, tombFinance]);

    // Calculate time remaining
    const getTimeRemaining = () => {
        if (!nextHarvestTime) return null;
        
        const now = new Date();
        const diffMs = nextHarvestTime.getTime() - now.getTime();
        
        if (diffMs <= 0) return 'Ready to harvest';
        
        const hours = Math.floor(diffMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        
        return `${hours}h ${minutes}m`;
    };

    return {
        nextHarvestTime,
        loading,
        getTimeRemaining,
    };
};

export default useNextHarvestTime; 